export const getMeshBase = () => window.location.pathname.startsWith('/billing') ? '/billing' : '/captain';

export const meshTablesPath = () => getMeshBase();
export const meshCustomerPath = tableId => `${getMeshBase()}/table/${tableId}/customer`;
export const meshMenuPath = tableId => `${getMeshBase()}/table/${tableId}/menu`;
export const meshSummaryPath = tableId => `${getMeshBase()}/table/${tableId}/summary`;
export const meshBillPath = tableId => `${getMeshBase()}/table/${tableId}/bill`;
export const meshKotsPath = tableId => `${getMeshBase()}/table/${tableId}/kots`;
